import Vue from 'vue';
import Vuelidate from 'vuelidate';

Vue.use(Vuelidate);

// components
import PasswordReset from '../vue/components/common/PasswordReset.vue';
import ChangePassword from '../vue/components/common/ChangePassword.vue';

export default {
  init() {
    // JavaScript to be fired on the home page

    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');


      new Vue({
          render (createElement) {
              if(token) {
                  return createElement(ChangePassword);
              }

              return createElement(PasswordReset);
          },
      }).$mount('#vue-password-reset');
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/passwordReset.js